import React from 'react'

function Info({icon, text}) {
  return (
    <div className='flex items-center gap-1 mb-2'>
      <p className='text-[20px] text-[#5b5b5b]'>{icon}</p>
      <p className='text-black'>{text}</p>
    </div>
  )
}

export default Info